import React, { useRef } from 'react';
import { useScrollFadeIn } from '../../utils/scrollFadeIn';

function Contact() {
  const sectionRef = useRef(null);

  useScrollFadeIn(sectionRef, '.contact-content', []);

  const handlePhoneClick = (e) => {
    // PC（タッチデバイスでない）場合はクリックを無効化
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  // タッチデバイスの検出をより確実に
  const isTouchDevice = typeof window !== 'undefined' && (
    'ontouchstart' in window || 
    navigator.maxTouchPoints > 0 || 
    navigator.msMaxTouchPoints > 0
  );
  
  // eslint-disable-next-line no-script-url
  const phoneHref = isTouchDevice ? 'tel:0166-53-3032' : '#';

  return (
    <section id="contact" className="contact" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">お問い合わせ</h2>
        <div className="contact-content fade-in">
          <div className="contact-phone">
            <p className="phone-number">
              <a 
                href={phoneHref} 
                onClick={handlePhoneClick}
                className={!isTouchDevice ? 'phone-link-disabled' : ''}
              >
                📞 0166-53-3032
              </a>
            </p>
            <p>
              （受付時間は営業日の11:00～20:00）
            </p>
          </div>
          {/* 関連リンク */}
          <div className="related-links">
            <h3>関連リンク</h3>
            <div className="link-icons">
              <a 
                href="https://www.instagram.com/yoshizushi.33/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="link-icon instagram"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a 
                href="https://tabelog.com/hokkaido/A0104/A010401/1013341/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="link-icon tabelog"
                aria-label="食べログ"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
                </svg>
              </a>
              <a 
                href="https://maps.app.goo.gl/k4i4Lap6twNnuZr46" 
                target="_blank" 
                rel="noopener noreferrer"
                className="link-icon googlemap"
                aria-label="Google Map"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

